<template>
  <div id="recomendacoes">
    <h1 id="title">{{ recomendacao }}</h1>
    
    <div class="">
      <ItemDestaque />
      <div v-for="(item, i) in novidades" :key="i" class="new-product-carousel">
        <p>Teste</p>
          <!-- <Product :product="item"/>   -->
        </div>
    </div>

  </div>
</template>

<script>
import ItemDestaque from './ItemDestaque';
export default {
  name: "recomendacoes",
  props: ["recomendacao", "lista", "novidades"],
  components: {ItemDestaque},
  async mounted() {
    
  },
};
</script>

<style>
#recomendacoes {
  margin-top: 20px;
  margin-bottom: 20px;
}

#recomendacoes #title {
  font-size: 22px;
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
  color: #000;
}
</style>
